class MvSlider {
  constructor(el, opt) {
    this.root = document.querySelector('.' + el);
    if (!this.root) return;

    this.interval = (opt && opt.interval) || 4160;
    this.duration = (opt && opt.duration) || 0.7;
    this.overlap = (opt && opt.overlap) || 0.2;
    this.gap = (opt && opt.gap) || 0.3;
    this.frames = Array.from(
      this.root.querySelectorAll('[data-mv-layer="frame"]')
    );
    this.people = Array.from(
      this.root.querySelectorAll('[data-mv-layer="people"]')
    );
    this.count = Math.min(this.frames.length, this.people.length);
    this.current = 0;
    this.busy = false;
    this.timer = null;
    this.reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (this.count < 2) return;

    this.setup();
    this.schedule();
  }

  setup() {
    this.frames.forEach((frame, index) => {
      gsap.set(frame, {
        clipPath: 'none',
        opacity: index === this.current ? 1 : 0,
      });
    });

    this.people.forEach((person, index) => {
      gsap.set(person, {
        opacity: index === this.current ? 1 : 0,
      });
    });
  }

  schedule() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.next();
    }, this.interval);
  }

  next() {
    if (this.busy || this.count < 2) return;

    const from = this.current;
    const to = (from + 1) % this.count;
    this.goTo(from, to);
  }

  setActive(from, to) {
    this.frames[from].classList.remove('is-active');
    this.people[from].classList.remove('is-active');
    this.frames[to].classList.add('is-active');
    this.people[to].classList.add('is-active');
    this.current = to;
  }

  goTo(from, to) {
    this.busy = true;

    if (this.reduceMotion) {
      gsap.set(this.people[from], { opacity: 0 });
      gsap.set(this.frames[from], { clipPath: 'none', opacity: 0 });
      gsap.set(this.frames[to], { clipPath: 'none', opacity: 1 });
      gsap.set(this.people[to], { opacity: 1 });
      this.setActive(from, to);
      this.busy = false;
      this.schedule();
      return;
    }

    const tl = gsap.timeline({
      onComplete: () => {
        this.setActive(from, to);
        this.busy = false;
        this.schedule();
      },
    });

    // 人物 → 背景（overlap 重なり）で消し、gap 空けてから背景 → 人物で出す
    tl.to(this.people[from], {
      opacity: 0,
      duration: this.duration,
      ease: 'sine.inOut',
    });
    tl.to(
      this.frames[from],
      {
        opacity: 0,
        duration: this.duration,
        ease: 'sine.inOut',
      },
      `-=${this.overlap}`
    );
    tl.to(
      this.frames[to],
      {
        opacity: 1,
        duration: this.duration,
        ease: 'sine.inOut',
      },
      `+=${this.gap}`
    );
    tl.to(
      this.people[to],
      {
        opacity: 1,
        duration: this.duration,
        ease: 'sine.inOut',
      },
      `-=${this.overlap}`
    );
  }
}
